import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {attendeeCheckedCount, importAvatar,importOneAvatar, attendeeCollectCount,
    attendeeExportPic, attendeEexportQrcode,attendeExportInfoQrcode,attendeeExportFile, attendeeExportCheckinCount,
    disableAttendees, disable2reject, qaAttendees, attendeeSmsSend, attendeeSmsSendall,
    attendeeCancel, attendeeSmsSendfirsttime,importContactAttendee,updateContactAttendee,
    attendeesIncludeCheckinLogs, attendeesDayCheckinCountStats,attendeesTailCheckinCountStats, attendeeByTicketId,
    importOrExportTasks, attendeeExport, attendeeImport, attendees,attendeesByids, attendee,
    attendeeApprove, attendeeDisapprove, attendeesStatusStats,
    attendeeFormChange,confirmationOpenedStats,confirmationOpened, attendeeIdList,
    attendeeExist,checkinpointTailExp,attendeeImportTemplate,attendeeLevelShare,attendeeUnbindUser} = api


/**
 * 勾选发送
 */
export async function findAttendeeIdList(params) {
    return request({url: attendeeIdList, method: 'get', data: params})
}

/**
 * 勾选发送
 */
export async function sendAttendeeSms(params) {
    return request({url: attendeeSmsSend, method: 'post', data: params,})
}

/**
 * 全部发送
 */
export async function sendallAttendeeSms(params) {
    return request({url: attendeeSmsSendall, method: 'post', data: params,})
}

/**
 * 发送未发送
 */
export async function sendfirsttimeAttendeeSms(params) {
    return request({url: attendeeSmsSendfirsttime, method: 'post', data: params,})
}

/**
 * 作废参与人
 */
export async function myDisableAttendees(params) {
    return request({url: disableAttendees, method: 'post', data: params})
}

export async function disable2rejectAttendees(params) {
    return request({url: disable2reject, method: 'post', data: params})
}

/**
 * 查找参与人列表
 */
export async function findAttendees(params) {
    return request({url: attendees, method: 'get', data: params,})
}
export async function findAttendeesByids(params) {
    return request({url: attendeesByids, method: 'get', data: params,})
}

export async function findQAAttendees(params) {
    return request({url: qaAttendees, method: 'get', data: params,})
}
/**
 * 查找参与人详情
 */
export async function findAttendee(params) {

    return request({url: attendee, method: 'get', data: params,})
}

export async function findAttendeeByTicketId(params) {

    return request({url: attendeeByTicketId, method: 'get', data: params,})
}

export async function findAttendeesStatusStats(params) {
    return request({url: attendeesStatusStats, method: 'get', data: params,})
}

export async function findAttendeesDayCheckinCountStats(params) {
    return request({url: attendeesDayCheckinCountStats, method: 'get', data: params,})
}
export async function findAttendeesTailCheckinCountStats(params) {
    return request({url: attendeesTailCheckinCountStats, method: 'get', data: params,})
}

export async function findAttendeesIncludeCheckinLogs(params) {
    return request({url: attendeesIncludeCheckinLogs, method: 'get', data: params,})
}

/**
 * 审核
 */
export async function approveAttendee(params) {
    return request({url: attendeeApprove, method: 'post', data: params,})
}

export async function disapproveAttendee(params) {
    return request({url: attendeeDisapprove, method: 'post', data: params,})
}


export async function updateAttendeeForm(attendeeId, params) {
    return request({url: `${attendeeFormChange}?attendeeId=${attendeeId}`, method: 'post', data: params,})
}

export async function patchAttendee(params) {
    return request({url: attendee, method: 'patch', data: params,})
}


/**
 * 删除
 */
export async function deleteAttendee(params) {
    return request({url: attendee, method: 'delete', data: params,})
}

/**
 * 导入参与人
 */
export async function importAttendee(params) {
    return request({url: attendeeImport, method: 'post', data: params,})
}/**
 * 通讯录导入参与人
 */
export async function importContactToAttendee(params) {
    return request({url: importContactAttendee, method: 'post', data: params,})
}

export async function updateContactToAttendee(params) {
    return request({url: updateContactAttendee, method: 'post', data: params,})
}

export async function exportAttendee(params) {
    return request({url: attendeeExport, method: 'get', data: params,})
}

export async function exportAttendeeCheckinCount(params) {
    return request({url: attendeeExportCheckinCount, method: 'post', data: params,})
}
export async function exportAttendeeCheckinTail(params) {
    return request({url: checkinpointTailExp, method: 'get', data: params,})
}
//导出参与人二维码
export async function exportAttendeeQrcode(params) {
    return request({url: attendeEexportQrcode, method: 'post', data: params,})
}
export async function exportAttendeeInfoQrcode(params) {
    return request({url: attendeExportInfoQrcode, method: 'post', data: params,})
}
export async function exportAttendeeFile(params) {
    return request({url: attendeeExportFile, method: 'post', data: params,})
}
//导出参与人图片
export async function exportAttendeePic(params) {
    return request({url: attendeeExportPic+'?showUnique='+params.showUnique, method: 'post', data: params})
}
export async function exportAttendeeCollectCount(params) {
    return request({url: attendeeCollectCount, method: 'get', data: params,})
}

export async function findTasks(params) {
    return request({url: importOrExportTasks, method: 'get', data: params,})
}

//取消任务
export async function cancelTasks(params) {
    return request({url: attendeeCancel, method: 'post', data: params,})
}

export async function batchAvatar(params) {
    return request({url: importAvatar, method: 'post', data: params})
}
export async function batchOneAvatar(params) {
    return request({url: importOneAvatar, method: 'post', data: params})
}

export async function countAttendeeChecked(params) {
    return request({url: attendeeCheckedCount, method: 'get', data: params})
}

export async function findConfirmationOpenedStats(params) {
    return request({url: confirmationOpenedStats, method: 'get', data: params})
}

export async function signConfirmationOpened(params) {
    return request({url: confirmationOpened, method: 'post', data: params})
}

export async function existAttendee(params) {
    return request({url: attendeeExist, method: 'get', data: params})
}

export async function getImportTemplate(params) {
    return request({url: attendeeImportTemplate, method: 'get', data: params})
}

export async function findAttendeeLevelShare(params) {
    return request({url: attendeeLevelShare, method: 'get', data: params})
}

export async function unBindAttendeeUser(params) {
    return request({url: attendeeUnbindUser, method: 'put', data: params})
}




// WEBPACK FOOTER //
// ./src/services/attendee.js